import Vue from "vue";
import './plugins/axios'
import App from "./App.vue";
import router from "./router";
import './plugins/element.js';
import store from './store';
import common from './common.js';
import config from './config.js';
import './api/index.js';
import './plugins/icon/iconfont.css';
import ysyapi from './plugins/ezuikit.js';
import echarts from 'echarts';
import myqrcode from './components/myqrcode.vue'

import crud from './components/crud.vue'
import tabsmenu from './components/tabs-menu.vue'
import picker from './components/my-date-picker.vue'
import cascader from './components/my-cascader.vue'
import latlong from './components/my-latlong.vue'
import select from './components/my-select.vue'
import selects from './components/my-selects.vue'
import upload from './components/my-upload.vue'
import uploads from './components/my-uploads.vue'
import file from './components/my-file.vue'
import phone from './components/my-phone.vue'
import packet from './components/my-packet.vue'
import duration from './components/duration-time.vue'

Vue.config.productionTip = false;
Vue.prototype.$echarts=echarts;

Vue.component('crud',crud);
Vue.component('tabs-menu',tabsmenu);
Vue.component('my-date-picker',picker);
Vue.component('my-cascader',cascader);
Vue.component('my-latlong',latlong);
Vue.component('my-select',select);
Vue.component('my-selects',selects);
Vue.component('my-upload',upload);
Vue.component('my-uploads',uploads);
Vue.component('my-file',file);
Vue.component('my-phone',phone);
Vue.component('my-packet',packet);
Vue.component('duration-time',duration);

Vue.component("my-qrcode",myqrcode);
Vue.use(config);
Vue.use(common);
Vue.use(ysyapi);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
